module.exports = __webpack_public_path__ + "img/top binding width.22f459f4.png";